import { atom } from "recoil";

import UserData = App.Data.UserData;

export interface SessionState {
    token: string | null;
    user: UserData | null;
    activeTenantSlug: string | null;
}

export const sessionAtom = atom<SessionState>({
    key: "sessionState",
    default: {
        token: null,
        user: null,
        activeTenantSlug: null,
    },
});
